import React, { useState, useEffect } from 'react';

if (!document.getElementById('katex-css')) {
  const link = Object.assign(document.createElement('link'), {
    id: 'katex-css', rel: 'stylesheet',
    href: 'https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.css',
  });
  document.head.appendChild(link);
}

function StoryCard({ post, onClick }) {
  return (
    <div className="project-card" style={{ cursor: 'pointer' }} onClick={onClick}>
      <div className="project-content" style={{ padding: '1.5rem' }}>
        <div className="project-header">
          <h4 style={{ marginBottom: '0.25rem' }}>{post.title}</h4>
          <span className="project-date">{new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
        </div>
        <p className="project-description" style={{ marginTop: '0.75rem', fontStyle: 'italic' }}>{post.excerpt}</p>
        <div className="project-links" style={{ marginTop: '1rem' }}>
          <span className="project-link" style={{ cursor: 'pointer' }}>Read →</span>
        </div>
      </div>
    </div>
  );
}

function StoryDetail({ post, onBack }) {
  return (
    <div className="project-card" style={{ maxWidth: 720, margin: '0 auto' }}>
      <div className="project-content" style={{ padding: '2rem' }}>
        <button
          onClick={onBack}
          style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'inherit', opacity: 0.6, marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.9rem' }}
        >
          ← Back
        </button>
        <h2 style={{ marginBottom: '0.5rem' }}>{post.title}</h2>
        <p style={{ opacity: 0.6, fontSize: '0.9rem', marginBottom: '2rem' }}>
          {new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>
        <div className="post-body" style={{ fontStyle: 'italic', lineHeight: 1.9 }} dangerouslySetInnerHTML={{ __html: post.content }} />
      </div>
    </div>
  );
}

export default function Stories() {
  const [posts, setPosts] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/stories.json', { cache: 'no-store' })
      .then(r => r.json())
      .then(data => {
        const published = (data.posts || []).filter(p => p.published).sort((a, b) => new Date(b.date) - new Date(a.date));
        setPosts(published);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  useEffect(() => { window.scrollTo(0, 0); }, [selected]);

  return (
    <div className="container" style={{ paddingTop: 'calc(72px + 2rem)' }}>
      {selected ? (
        <StoryDetail post={selected} onBack={() => setSelected(null)} />
      ) : (
        <div className="main-content">
          <div className="projects-section">
            <h3 className="section-title">Stories</h3>
            {loading && <p style={{ opacity: 0.5 }}>Loading...</p>}
            {!loading && posts.length === 0 && <p style={{ opacity: 0.5 }}>No stories yet.</p>}
            <div className="projects-grid">
              {posts.map(post => (
                <StoryCard key={post.id} post={post} onClick={() => setSelected(post)} />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
